<template>
  <b-container class="cart-page py-4">
    <h1 class="mb-4">Carrito de Compras</h1>
    
    <div v-if="cartItems.length === 0" class="text-center py-5">
      <b-icon icon="cart-x" font-scale="5" variant="secondary"></b-icon>
      <h3 class="mt-3">Tu carrito está vacío</h3>
      <p class="text-muted">Agrega algunos productos para comenzar</p>
      <b-button variant="primary" :to="{ name: 'Products' }">
        Ver Productos
      </b-button>
    </div>
    
    <b-row v-else>
      <b-col lg="8">
        <b-card class="mb-4">
          <b-table 
            :items="cartItems" 
            :fields="fields"
            responsive
            class="cart-table">
            
            <template #cell(product)="data">
              <div class="d-flex align-items-center">
                <b-img
                  :src="data.item.image"
                  :alt="data.item.name"
                  width="60"
                  height="60"
                  class="mr-3"
                  @error="onImageError">
                </b-img>
                <div>
                  <strong>{{ data.item.name }}</strong>
                </div>
              </div>
            </template>
            
            <template #cell(price)="data">
              ${{ formatPrice(data.item.price) }}
            </template>
            
            <template #cell(quantity)="data">
              <b-form-spinbutton 
                :value="data.item.quantity" 
                min="1"
                max="999"
                @change="updateQuantity(data.item.id, $event)"
                size="sm"
                inline>
              </b-form-spinbutton>
            </template>
            
            <template #cell(subtotal)="data">
              <strong>${{ formatPrice(data.item.price * data.item.quantity) }}</strong>
            </template>
            
            <template #cell(actions)="data">
              <b-button 
                variant="danger" 
                size="sm"
                @click="removeItem(data.item.id)">
                <b-icon icon="trash"></b-icon>
              </b-button>
            </template>
          </b-table>
          
          <div class="text-right">
            <b-button variant="outline-danger" @click="clearCart">
              Vaciar Carrito
            </b-button>
          </div>
        </b-card>
      </b-col>
      
      <b-col lg="4">
        <b-card title="Resumen del Pedido" class="sticky-top">
          <b-list-group flush>
            <b-list-group-item class="d-flex justify-content-between">
              <span>Subtotal:</span>
              <strong>${{ formatPrice(subtotal) }}</strong>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between">
              <span>Envío:</span>
              <span>A calcular</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between">
              <h5 class="mb-0">Total:</h5>
              <h5 class="mb-0 text-success">${{ formatPrice(subtotal) }}</h5>
            </b-list-group-item>
          </b-list-group>
          
          <b-button 
            variant="success" 
            size="lg"
            block
            class="mt-3"
            @click="proceedToCheckout">
            Proceder al Pago
            <b-icon icon="arrow-right" class="ml-2"></b-icon>
          </b-button>
          
          <b-button 
            variant="outline-primary" 
            block
            :to="{ name: 'Products' }">
            Seguir Comprando
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'ShoppingCart',
  data() {
    return {
      fields: [
        { key: 'product', label: 'Producto' },
        { key: 'price', label: 'Precio' },
        { key: 'quantity', label: 'Cantidad' },
        { key: 'subtotal', label: 'Subtotal' },
        { key: 'actions', label: '' }
      ]
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.cart
    },
    subtotal() {
      return this.$store.getters.cartTotal
    }
  },
  created() {
    this.$store.dispatch('loadCartFromStorage')
  },
  methods: {
    onImageError(e) {
      e.target.src = require('@/assets/images/product-placeholder.svg')
    },
    formatPrice(price) {
      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price)
    },
    updateQuantity(productId, quantity) {
      this.$store.dispatch('updateCartQuantity', { productId, quantity })
    },
    removeItem(productId) {
      this.$bvModal.msgBoxConfirm('¿Estás seguro de eliminar este producto del carrito?', {
        title: 'Confirmar eliminación',
        okVariant: 'danger',
        okTitle: 'Eliminar',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value) {
          this.$store.dispatch('removeFromCart', productId)
          this.$bvToast.toast('Producto eliminado del carrito', {
            title: 'Eliminado',
            variant: 'info',
            solid: true
          })
        }
      })
    },
    clearCart() {
      this.$bvModal.msgBoxConfirm('¿Estás seguro de vaciar todo el carrito?', {
        title: 'Confirmar',
        okVariant: 'danger',
        okTitle: 'Vaciar',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value) {
          this.$store.dispatch('clearCart')
        }
      })
    },
    proceedToCheckout() {
      const config = this.$store.getters.shopConfig
      const isAuthenticated = this.$store.getters.isAuthenticated
      
      if (!config.allow_sale_unlogged && !isAuthenticated) {
        this.$bvToast.toast('Debes iniciar sesión para continuar', {
          title: 'Autenticación requerida',
          variant: 'warning',
          solid: true
        })
        this.$router.push({ name: 'Login' })
      } else {
        this.$router.push({ name: 'Checkout' })
      }
    }
  }
}
</script>

<style scoped>
.cart-table img {
  object-fit: cover;
  border-radius: 0.25rem;
}

.sticky-top {
  top: 80px;
}
</style>